const map = {
    'tool': '工具',
    'device': '设备',
    'role': '角色',
    'scene': '场景',
}


export default path => {
    if (path.startsWith('/')) {
        path = path.substring(1);
    }
    if (path.endsWith('lib')){
        path = path.substring(0, path.length - 3)
    }
    return {
        category: path,
        cn_name: map[path],
    }
};